module.exports = __webpack_public_path__ + "img/button-delete.f6a83d0d.svg";